import type { FC, ComponentPropsWithoutRef } from 'react';
import styles from './styles.module.scss';

interface CheckboxProps extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange' | 'checked' | 'type'> {
    label: string;
    error?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const Checkbox: FC<CheckboxProps> = ({ label, checked, onChange, error, ...inputProps }) => (
    <label className={styles['checkbox-group']} data-validation-error={error ? 'true' : undefined}>
        <input
            aria-invalid={!!error}
            {...inputProps}
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
        />
        <span className={styles['checkbox-box']}>
            <svg className={styles['checkbox-mark']} viewBox="0 0 12 12" fill="none">
                <path d="M2 6L5 9L10 3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
        <span className={styles['checkbox-label']}>{label}</span>
    </label>
);
